// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3GkXZ","colMaxWidth":"Table_colMaxWidth__3WCcU"};